// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"758":"65a6c49de5f0037e","6378":"aa022148f9dbe8c5"}[chunkId] + ".css";
};